// extracted by mini-css-extract-plugin
var _1 = "ad-group-column___nPGLq";
var _2 = "bulk-edit-row___xuIpy";
var _3 = "empty-table-text___tGs6f";
var _4 = "field___zHQIO";
var _5 = "header-label___lqHcX";
var _6 = "match-type-column___aWc5P";
var _7 = "remove-column___AJCqA";
export { _1 as "ad-group-column", _2 as "bulk-edit-row", _3 as "empty-table-text", _4 as "field", _5 as "header-label", _6 as "match-type-column", _7 as "remove-column" }
